import request from '@/utils/request';

const path = 'api/v1';

export const agencyCreate = (data?: object) => request({
  url: `${path}/agency/agencyCreate`,
  method: 'POST',
  data,
});

export const agencyList = (data?: object) => request({
  url: `${path}/agency/agencyList`,
  method: 'Get',
  params: data,
});

export const agencyUpdate = (data?: object) => request({
  url: `${path}/agency/agencyUpdate`,
  method: 'POST',
  data,
});

export const agencyDelete = (data?: object) => request({
  url: `${path}/agency/agencyDelete`,
  method: 'POST',
  data,
});
